function StatCard({ label, value, color }: { label: string; value: string | number; color?: string }) {
  return (
    <div className="rounded-lg border border-slate-800/60 bg-slate-950/40 p-4 flex-1 min-w-[140px] shadow-sm font-mono">
      <div className="text-[10px] font-semibold text-slate-400 uppercase tracking-wider">{label}</div>
      <div className={`mt-1 text-2xl font-bold ${color || 'text-slate-100'}`}>{value}</div>
    </div>
  );
}

function BandwidthBar({ label, used, total, color }: { label: string; used: number; total: number; color: string }) {
  const pct = total > 0 ? Math.round((used / total) * 100) : 0;
  return (
    <div className="space-y-1.5 font-mono">
      <div className="flex justify-between text-xs">
        <span className="text-slate-300">{label}</span>
        <span className="text-slate-400">{used}/{total} ({pct}%)</span>
      </div>
      <div className="w-full bg-slate-950 border border-slate-800/80 rounded-full h-2">
        <div className="h-full rounded-full transition-all" style={{ width: `${pct}%`, backgroundColor: color }} />
      </div>
    </div>
  );
}

export function ConnectivityBandwidthTab({ bandwidth }: { bandwidth: any }) {
  if (!bandwidth) return null;

  return (
    <div>
      <h2 className="text-base font-semibold font-mono text-slate-100 mb-4">Использование пропускной способности</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        <StatCard label="Всего портов" value={bandwidth.total_ports} />
        <StatCard label="Подключено" value={bandwidth.connected_ports} />
        <StatCard label="Утилизация" value={`${bandwidth.utilization_pct}%`} color="text-cyan-400" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-slate-950/40 border border-slate-800/50 rounded-lg p-4">
          <h3 className="text-xs font-mono font-semibold uppercase tracking-wider text-slate-400 mb-4">По типу порта</h3>
          <div className="space-y-4">
            {Object.entries(bandwidth.by_port_type || {}).map(([t, v]: [string, any]) => (
              <BandwidthBar key={t} label={t} used={v.connected} total={v.total} color="#06b6d4" />
            ))}
          </div>
        </div>
        <div className="bg-slate-950/40 border border-slate-800/50 rounded-lg p-4">
          <h3 className="text-xs font-mono font-semibold uppercase tracking-wider text-slate-400 mb-4">По типу кабеля</h3>
          <div className="space-y-4">
            {Object.entries(bandwidth.by_cable_type || {}).map(([t, v]: [string, any]) => (
              <BandwidthBar key={t} label={`${t} (${v.utilized} использовано)`} used={v.utilized} total={v.total} color="#10b981" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
